import { Auth } from 'aws-amplify'
import { CognitoUserSession } from 'amazon-cognito-identity-js'

export const client = async (
  endpoint: string,
  body?: {},
  method?: 'POST' | 'GET' | 'DELETE' | 'PUT',
  cognitoSession: CognitoUserSession | undefined = undefined
) => {
  let headers: HeadersInit
  if (cognitoSession && !cognitoSession.isValid()) {
    cognitoSession = await simpleGetSessionNoDecoration()
  }

  if (cognitoSession) {
    let authorization = cognitoSession.getIdToken().getJwtToken()
    headers = {
      'Content-Type': 'application/json',
      authorization: authorization
    }
  } else {
    headers = {
      'Content-Type': 'application/json'
    }
  }
  const config: RequestInit = {
    method: method ? method : body ? 'POST' : 'GET',
    headers: headers
  }

  if (body) {
    config.body = JSON.stringify(body)
  }

  return window.fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, config).then(response => {
    if (!response.ok) {
      return response.json().then(err => {
        const msg = err.ErrorDescription ?? err.StatusDescription
        return Promise.reject(`Request Error: ${msg}`)
      })
    } else {
      const isJSONResponse = response.headers.get('Content-type')?.startsWith('application/json')
      return isJSONResponse ? response.json() : response.text()
    }
  })
}

async function simpleGetSessionNoDecoration() {
  return Auth.currentSession()
}

// export const isIncidentAdminUserForAgency = (session: CognitoUserSession | null, agency: AGENCY | undefined) => {
//   if (!session || !agency) {
//     return false
//   }

//   if (isPulsePointSuperUser(session)) {
//     return true
//   }

//   try {
//     return JSON.parse(session.getIdToken().payload['permissions'])[agency.agencyid]['PPAdmin']
//   } catch (error) {
//     return false
//   }
// }
